import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'academics',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './academics.component.html',
  styleUrl: './academics.component.css'
})
export class AcademicsComponent implements OnInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  yesNo = EYesNo;
  academicsForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "How is this student doing academically? *",
      formControlName: "student_academics",
    },
    {
      question: "How well does the student express himself/herself verbally? In writing? *",
      formControlName: "verbal_expression",
    }
  ]

  radioQuestions = [
    {
      id: 'change_academic_performance',
      questionText: 'Have there been any recent changes in academic performance? *',
      formControlName: 'change_academic_performance',
      infoFormControlName: 'change_academic_performance_information'
    },
    {
      id: 'intervention_programming',
      questionText: 'Does this student receive intervention programming or specialized instruction? *',
      formControlName: 'intervention_programming',
      infoFormControlName: 'intervention_programming_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }  
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};

    this.radioQuestions.forEach(question => {
      const defaultValue = this.teacherStaffInterviewData && this.teacherStaffInterviewData[question.formControlName] !== undefined
                           ? this.teacherStaffInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.teacherStaffInterviewData?.[question.infoFormControlName] || '', disabled: this.teacherStaffInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.teacherStaffInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.academicsForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.academicsForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.academicsForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }  

  saveAcademics(): void {
    if (this.academicsForm.valid) {
      this.onSaveSection3.emit(this.academicsForm.value);
    }
  }

}
